import { defineMessages } from "react-intl"

export default defineMessages({
  controllers: {
    id: "app.components.ControllerExperience.controllers",
  },
  fpsControllers: {
    id: "app.components.ControllerExperience.fpsControllers",
  },
  "controllers.PlayStation3": {
    id: "app.components.ControllerExperience.controllers.PlayStation3",
  },
  "controllers.PlayStation4": {
    id: "app.components.ControllerExperience.controllers.PlayStation4",
  },
  "controllers.Xbox360": {
    id: "app.components.ControllerExperience.controllers.Xbox360",
  },
  "controllers.XboxOne": {
    id: "app.components.ControllerExperience.controllers.XboxOne",
  },
  "controllers.Switch": {
    id: "app.components.ControllerExperience.controllers.Switch",
  },
  "controllers.MouseAndKeyboard": {
    id: "app.components.ControllerExperience.controllers.MouseAndKeyboard",
  },
  "controllers.Mobile": {
    id: "app.components.ControllerExperience.controllers.Mobile",
  },
  "controllers.XboxAccessibilityController": {
    id: "app.components.ControllerExperience.controllers.XboxAccessibilityController",
  },
  "controllers.EyeTracker": {
    id: "app.components.ControllerExperience.controllers.EyeTracker",
  },
  "controllers.Stadia": {
    id: "app.components.ControllerExperience.controllers.Stadia",
  },
  "controllers.PlayStation5": {
    id: "app.components.ControllerExperience.controllers.PlayStation5",
  },
  "controllers.XboxSeriesX|S": {
    id: "app.components.ControllerExperience.controllers.XboxSeriesX|S",
  },  
})
